import {
  BoxProps,
  styled,
  Box,
  LinearProgress as MuiLinearProgress,
} from '@mui/material'

export const LinearProgress = styled((props: BoxProps) => (
  <Box {...props}>
    <MuiLinearProgress color={'inherit'} sx={{ height: '4px' }} />
  </Box>
))(({ theme }) => ({
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 400,
  color: theme.palette.primary.main,
}))
